export default "__VITE_ASSET__o37R2XLi__"